import React, { useState } from "react";
import {
  Box,
  Text,
  Flex,
  List,
  Modal,
  Radio,
  Image,
  Button,
  Spinner,
  Divider,
  useToast,
  ListItem,
  ModalBody,
  FormLabel,
  RadioGroup,
  ModalFooter,
  ModalOverlay,
  ModalContent,
  useDisclosure,
  Tooltip,
} from "@chakra-ui/react";
import { useFormik } from "formik";

import { useUserContext } from "context/UserContext";
import FormikSelect from "components/formikSelect";
import PreferItemNoteModal from "./PreferItemNoteModal";
import RequestReceivedModal from "./RequestReceivedModal";
import useRequestBags from "api/mutations/useRequestBags";
import useGetCharities from "api/queries/useGetCharities";

const RequestABagModal = ({ isOpen, onClose }) => {
  const toast = useToast();
  const { user } = useUserContext();
  // const [isDonateToCharity, setIsDonateToCharity] = useState(null);
  const {
    isOpen: isRequestReceivedOpen,
    onOpen: onRequestReceivedOpen,
    onClose: onRequestReceivedClose,
  } = useDisclosure();
  const {
    isOpen: isPreferItemNoteModalOpen,
    onOpen: onPreferItemNoteModalOpen,
    onClose: onPreferItemNoteModalClose,
  } = useDisclosure();

  // const charityQuery = useGetCharities();
  // const charities = charityQuery?.data?.data || [];

  const formik = useFormik({
    initialValues: {
      number_of_bags: 0,
      number_of_items_requested: "",
      // drop_at_location: null,
      // donate_to_charity: null,
    },
    onSubmit: (values) => submitRequest(values),
  });

  const requestBagsMutation = useRequestBags({
    onSuccess: (res) => {
      if (res.status === 200) onRequestReceivedOpen();
    },
    onError: (err) => {
      toast({
        title: "Failed to request bags",
        status: "error",
        duration: 3000,
        isClosable: true,
      });
    },
  });

  const submitRequest = (values) => {
    try {
      const data = {
        number_of_items_requested: values.number_of_items_requested,
        number_of_bags: parseInt(values.number_of_bags),
        seller_id: user?.info?._id,
        // charityId: values?.donate_to_charity,
        // returned: !isDonateToCharity,
      };
      requestBagsMutation.mutate(data);
    } catch (error) {
      toast({
        title: "Something went wrong",
        status: "error",
        duration: 3000,
        isClosable: true,
      });
    }
  };

  const handleRequestFinish = () => {
    onRequestReceivedClose();
    onClose();
  };

  return (
    <Modal isOpen={isOpen} onClose={onClose} isCentered={true}>
      <ModalOverlay />
      <ModalContent minH={"300px"} minW={"800px"} p={4} borderRadius={"16px"}>
        <ModalBody display={"flex"} flexDirection={"column"} gap={4}>
          <Text
            color={"#000000"}
            fontFamily="PlusJakartaSansSemiBold"
            fontSize={"24px"}
            lineHeight={"32px"}
            textTransform={"capitalize"}
          >
            Request a Bag
          </Text>
          <Divider />
          <Box>
            <Text
              color={"#000000"}
              fontFamily="PlusJakartaSansSemiBold"
              fontSize={"16px"}
              lineHeight={"22px"}
              textTransform={"capitalize"}
              mb={2}
            >
              Request Details
            </Text>
            <Box
              border="1px solid #D9D9D9"
              borderRadius="8px"
              p={4}
              display={"flex"}
              flexDirection={"column"}
              gap={3}
            >
              <Flex direction={"column"} gap={1}>
                <Flex gap={2} alignItems={"center"}>
                  <FormLabel
                    fontFamily={"PlusJakartaSansMedium"}
                    fontSize={12}
                    color={"#000000"}
                    margin={0}
                  >
                    How many items are you sending?
                  </FormLabel>
                  <Tooltip
                    hasArrow
                    placement="bottom-start"
                    bg="#D9D9D9"
                    color="black"
                    p={3}
                    borderRadius="md"
                    boxShadow="md"
                    fontSize="sm"
                    maxWidth="32rem"
                    label={
                      <List spacing={1} styleType="disc" pl={2}>
                        <ListItem
                          fontSize={"10px"}
                          fontFamily={"PlusJakartaSansRegular"}
                          color={"#000000"}
                        >
                          <Text as="span" fontWeight="bold">
                            Condition
                          </Text>{" "}
                          - All items must be gently worn (or new with/without
                          tag)
                        </ListItem>
                        <ListItem
                          fontSize={"10px"}
                          fontFamily={"PlusJakartaSansRegular"}
                          color={"#000000"}
                        >
                          <Text as="span" fontWeight="bold">
                            Price
                          </Text>{" "}
                          - original RRP must be{" "}
                          <Text as="span" fontWeight="bold">
                            £45
                          </Text>{" "}
                          or greater
                        </ListItem>
                        <ListItem
                          fontSize={"10px"}
                          fontFamily={"PlusJakartaSansRegular"}
                          color={"#000000"}
                        >
                          <Text as="span" fontWeight="bold">
                            Brands
                          </Text>{" "}
                          - we accept all designer brands but not high street or
                          fast fashion
                        </ListItem>
                        <ListItem
                          fontSize={"10px"}
                          fontFamily={"PlusJakartaSansRegular"}
                          color={"#000000"}
                        >
                          <Text as="span" fontWeight="bold">
                            Cleaning
                          </Text>{" "}
                          - for items that require cleaning we charge
                          <Text as="span" fontWeight="bold">
                            {" "}
                            £3.95
                          </Text>{" "}
                          for garments or
                          <Text as="span" fontWeight="bold">
                            {" "}
                            £5.95
                          </Text>{" "}
                          for outerwear
                        </ListItem>
                      </List>
                    }
                  >
                    <Image
                      src={require("assets/svgs/info-circle.svg").default}
                      width={"16px"}
                      height={"16px"}
                      pos={"relative"}
                      _hover={{
                        cursor: "pointer",
                      }}
                    />
                  </Tooltip>
                </Flex>
                <FormikSelect
                  formik={formik}
                  name="number_of_items_requested"
                  label=""
                  labelColor={"black"}
                  placeholder={"Select one........"}
                >
                  <option value={"0-10"}>0-10</option>
                  <option value={"10-20"}>10-20</option>
                  <option value={"20-30"}>20-30</option>
                  <option value={"30-40"}>30-40</option>
                  <option value={"40-50"}>40-50</option>
                </FormikSelect>
              </Flex>
              <Flex direction={"column"} gap={1}>
                <Flex gap={2} alignItems={"center"}>
                  <FormLabel
                    fontFamily={"PlusJakartaSansMedium"}
                    fontSize={12}
                    color={"#000000"}
                    margin={0}
                  >
                    How many bags would you like?
                  </FormLabel>
                  <Tooltip
                    hasArrow
                    placement="bottom-start"
                    bg="#D9D9D9"
                    color="black"
                    p={3}
                    borderRadius="md"
                    boxShadow="md"
                    fontSize="sm"
                    maxWidth="32rem"
                    label={
                      <List spacing={1} styleType="disc" pl={2}>
                        <ListItem
                          fontSize={"10px"}
                          fontFamily={"PlusJakartaSansRegular"}
                          color={"#000000"}
                        >
                          Bag normally takes 25 garments or less depending on
                          the outerwear
                        </ListItem>
                      </List>
                    }
                  >
                    <Image
                      src={require("assets/svgs/info-circle.svg").default}
                      width={"16px"}
                      height={"16px"}
                      pos={"relative"}
                      _hover={{
                        cursor: "pointer",
                      }}
                    />
                  </Tooltip>
                </Flex>
                <FormikSelect
                  formik={formik}
                  name="number_of_bags"
                  label=""
                  labelColor={"black"}
                  placeholder={"Select one........"}
                  // infoCircle
                  // infoIconClick={() => onBagNoteModalOpen()}
                >
                  <option value={1}>1</option>
                  <option value={2}>2</option>
                  <option value={3}>3</option>
                  <option value={4}>4</option>
                  <option value={5}>5</option>
                </FormikSelect>
              </Flex>
              {/* <Flex direction={"column"} gap={2}>
                <Flex
                  flex={1}
                  justify={"space-between"}
                  alignItems={"center"}
                  mb={4}
                >
                  <Flex gap={2} alignItems={"center"}>
                    <FormLabel
                      fontFamily={"PlusJakartaSansMedium"}
                      fontSize={12}
                      color={"#000000"}
                      margin={0}
                    >
                      What do you want us to do with your rejected items?
                    </FormLabel>
                    <Tooltip
                      hasArrow
                      placement="bottom"
                      bg="#D9D9D9"
                      color="black"
                      p={3}
                      borderRadius="md"
                      boxShadow="md"
                      fontSize="sm"
                      maxWidth="32rem"
                      label={
                        <List spacing={1} styleType="disc" pl={2}>
                          <ListItem
                            fontSize={"10px"}
                            fontFamily={"PlusJakartaSansRegular"}
                            color={"#444444"}
                          >
                            Please check for any stains, tears, pulls
                          </ListItem>
                          <ListItem
                            fontSize={"10px"}
                            fontFamily={"PlusJakartaSansRegular"}
                            color={"#444444"}
                          >
                            Rejected items incur a return charge of{" "}
                            <Text as="span" fontWeight="bold">
                              £2.95
                            </Text>{" "}
                            per item
                          </ListItem>
                        </List>
                      }
                    >
                      <Image
                        src={require("assets/svgs/info-circle.svg").default}
                        width={"16px"}
                        height={"16px"}
                        pos={"relative"}
                        _hover={{
                          cursor: "pointer",
                        }}
                      />
                    </Tooltip>
                  </Flex>
                  <RadioGroup
                    name={"rejected_item_status"}
                    value={
                      isDonateToCharity !== null
                        ? isDonateToCharity.toString()
                        : ""
                    }
                    onChange={(val) => {
                      setIsDonateToCharity(val === "true");
                      if (val === "false") {
                        onPreferItemNoteModalOpen();
                      }
                    }}
                  >
                    <Flex>
                      <Radio
                        value="true"
                        fontFamily={"PlusJakartaSansMedium"}
                        fontSize={12}
                        mr={4}
                        color={"#000000"}
                      >
                        Donate to Charity
                      </Radio>
                      <Radio
                        value="false"
                        fontFamily={"PlusJakartaSansMedium"}
                        fontSize={12}
                        color={"#000000"}
                      >
                        Returned
                      </Radio>
                    </Flex>
                  </RadioGroup>
                </Flex>
                {isDonateToCharity && (
                  <FormikSelect
                    formik={formik}
                    name="donate_to_charity"
                    label="Select charity you wish to donate."
                    labelColor={"#000000"}
                    placeholder={"Select one........"}
                  >
                    {charities.map((charity) => (
                      <option key={charity._id} value={charity._id}>
                        {charity.name}
                      </option>
                    ))}
                  </FormikSelect>
                )}
              </Flex> */}
            </Box>
          </Box>
        </ModalBody>
        <ModalFooter>
          <Flex w={"100%"} justify={"end"} gap={4}>
            <Button
              bg={"transparent"}
              border={"1px solid #000000"}
              color="#000000"
              size="12px"
              borderRadius="12px"
              fontFamily="PlusJakartaSansMedium"
              w={"174px"}
              h={"40px"}
              textTransform={"uppercase"}
              onClick={onClose}
            >
              Cancel
            </Button>
            <Button
              bg="#000000"
              borderRadius="12px"
              color="#FFFFFF"
              size="12px"
              fontFamily="PlusJakartaSansMedium"
              w={"174px"}
              h={"40px"}
              textTransform={"uppercase"}
              onClick={formik.handleSubmit}
            >
              {requestBagsMutation.isLoading ? <Spinner /> : "SAVE"}
            </Button>
          </Flex>
        </ModalFooter>
      </ModalContent>
      <PreferItemNoteModal
        onClose={onPreferItemNoteModalClose}
        isOpen={isPreferItemNoteModalOpen}
      />
      <RequestReceivedModal
        onClose={handleRequestFinish}
        isOpen={isRequestReceivedOpen}
      />
    </Modal>
  );
};

export default RequestABagModal;
